import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGa4, trackPageView } from "./ga4";

// Task 20 — fires one GA4 page_view per client-side navigation.
// Independent from the internal heatmap (lib/tracking.js), which is untouched.
export default function Ga4RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    initGa4();
  }, []);

  useEffect(() => {
    trackPageView({
      pathname: location.pathname,
      search: location.search,
      title: document.title,
    });
  }, [location.pathname, location.search, location.key]);

  return null;
}
